<!--仅作为换购列表使用-->
<template>
  <div class="productList" v-wechat-title="title">
    <div class="list">
      <div class="itemA" v-for="(item, index) in list" :key="index">
        <div class="itemWrap" v-for="(itemB, indexB) in item.changebuylist" :key="item.skuid">
          <div class="item flex-ac">
            <van-checkbox
              v-model="itemB.ischoose"
              checked-color="#FC0324"
              @click="choice(index, indexB)"
            ></van-checkbox>
            <img v-lazy="itemB.img_path" @click.stop="godetail(itemB)" />
            <div class="rightBox" @click.stop="godetail(itemB)">
              <p class="name over-ell-1">{{ itemB.name }}</p>
              <p class="oldPrice">原价¥{{ itemB.cost_price }}</p>
              <div class="flex-js-ac">
                <p class="currentPrice">
                  <span class="lable">加购价¥</span>
                  <span class="price">{{ itemB.changebuy_price }}</span>
                </p>
                <div class="stepBox flex-js-ac">
                  <div
                    :class="[itemB.num <= 1 ? 'can' : '', 'subtract stepBtn']"
                    @click.stop="addToCart(0, index, indexB, itemB)"
                  ></div>
                  <div class="num">{{ itemB.num }}</div>
                  <div
                    :class="[itemB.num < itemB.canbuycnt ? 'can' : '', 'add stepBtn']"
                    @click.stop="addToCart(1, index, indexB, itemB)"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div class="ysale" v-if="itemB.presaletime" style="padding-left: 0.1rem">
            <van-tag color="#FEE9E6" text-color="#F12A0E">预售</van-tag>
            <img src="../../assets/images/presell.png" />
            <div class="txt">预售发货时间：{{ itemB.presaletime }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="btnBox">
      <div class="submitBtn" @click="submit">
        确定{{ totalNumber ? '(' + totalNumber + ')' : '' }}
      </div>
    </div>
  </div>
</template>

<script>
import { unencryption } from '../../assets/common/js/config'
import { Tag } from 'vant'

export default {
  name: 'productList',
  data() {
    return {
      list: null, // 换购列表
      totalNumber: 0,
      maxcanbuycnt: 0,
      title: ''
    }
  },
  components: {
    [Tag.name]: Tag
  },
  created() {
    this.getGoodsList()
  },
  methods: {
    getGoodsList() {
      let that = this,
        skuids = this.$route.query.skuids,
        url,
        itemnum = this.$route.query.itemnum ? this.$route.query.itemnum : ''

      url = this.$ajax.getExchangeItemList_URL + '?skuids=' + skuids + '&itemnum=' + itemnum
      if (this.$route.query.isexchange == 1) {
        this.title = this.$route.meta.title = '超值加购'
        url = this.$ajax.getAllExchangeItemList_URL + '?skuids=' + skuids + '&itemnum=' + itemnum
      } else {
        this.title = this.$route.meta.title = '超值换购'
      }
      url = this.$route.query.oid ? url + '&orderid=' + this.$route.query.oid : url

      try {
        this.$customRequestAjax(url)
          .then(function (res) {
            if (res.data.code === 200) {
              let list = res.data.data,
                oldList =
                  localStorage.getItem('shopConfirmResult') &&
                  JSON.parse(localStorage.getItem('shopConfirmResult')).changebuy_list
                    ? JSON.parse(
                        JSON.parse(localStorage.getItem('shopConfirmResult')).changebuy_list
                      )
                    : []

              if (that.$route.query.isexchange == 1) that.maxcanbuycnt = list[0].maxcanbuycnt

              for (let i = 0; i < list.length; i++) {
                let changebuytip = list[i].changebuytip,
                  changebuylist = list[i].changebuylist

                changebuytip = changebuytip.replace(/[\r\n]/g, '&')
                list[i].tipLable = changebuytip.substring(0, changebuytip.indexOf('&'))
                list[i].tipTime = changebuytip.substring(changebuytip.indexOf('&') + 1)

                for (let j = 0; j < changebuylist.length; j++) {
                  if (oldList && oldList.length) {
                    for (let k = 0; k < oldList.length; k++) {
                      if (changebuylist[j].skuid === oldList[k].skuid) {
                        changebuylist[j].num =
                          changebuylist[j].canbuycnt > oldList[k].num
                            ? oldList[k].num
                            : changebuylist[j].canbuycnt
                        changebuylist[j].ischoose = oldList[k].ischoose
                        break
                      } else {
                        if (that.$route.query.isexchange == 1 && that.maxcanbuycnt == 100000) {
                          changebuylist[j].num = 1
                        } else {
                          changebuylist[j].num = changebuylist[j].canbuycnt
                        }
                      }
                    }
                  } else {
                    if (that.$route.query.isexchange == 1 && that.maxcanbuycnt == 100000) {
                      changebuylist[j].num = 1
                    } else {
                      changebuylist[j].num = changebuylist[j].canbuycnt
                    }
                  }
                }
              }
              that.list = list
              that.count()
            } else {
            }
          })
          .catch((err) => {})
      } catch (e) {}
    },
    // 商品数量加减
    addToCart(type, index, indexB, item) {
      if (
        this.totalNumber + 1 > this.maxcanbuycnt &&
        type == 1 &&
        this.$route.query.isexchange == 1
      ) {
        this.$toast('超出最大可加购数量')
        return
      }
      let num = parseInt(item.num),
        max = parseInt(item.canbuycnt)
      if (type) {
        if (num >= max) {
          this.$toast('最多可购买' + max + '件')
          return
        }
        num += 1
      } else {
        if (num <= 1) {
          this.$toast('不能再减了')
          return
        }
        num += -1
      }

      this.list[index].changebuylist[indexB].num = num
      this.count()
    },

    // 选择/取消选择
    choice(index, indexB) {
      if (
        this.totalNumber + this.list[index].changebuylist[indexB].num > this.maxcanbuycnt &&
        this.list[index].changebuylist[indexB].ischoose &&
        this.$route.query.isexchange == 1
      ) {
        this.list[index].changebuylist[indexB].ischoose = 0
        this.$toast('超出最大可加购数量')
        return
      }
      this.list[index].changebuylist[indexB].ischoose = this.list[index].changebuylist[indexB]
        .ischoose
        ? 1
        : 0
      this.count()
    },
    // 计算已选中的商品数量
    count() {
      let totalNumber = 0,
        list = this.list
      for (let i = 0; i < list.length; i++) {
        let changebuylist = list[i].changebuylist
        for (let j = 0; j < changebuylist.length; j++) {
          if (changebuylist[j].ischoose) {
            totalNumber += changebuylist[j].num
          }
        }
      }
      this.totalNumber = totalNumber
    },
    godetail(items) {
      this.$router.push({
        path: '/productdetail',
        query: {
          itemid: items.itemid,
          type: 'changebuyproductdetail'
        }
      })
    },
    // 跳转至加购规则页
    goExchangeRule(changebuyrule) {
      if (this.$route.query.isexchange == 1) return
      window.location.href =
        'static/wx/html/exchangeRule.html?acttime=' +
        changebuyrule.acttime +
        '&productname=' +
        encodeURIComponent(changebuyrule.productname) +
        '&changebuyproductname=' +
        encodeURIComponent(changebuyrule.changebuyproductname)
    },
    // 提交加购商品
    submit() {
      let currentList = [],
        list = this.list,
        url,
        shopConfirmResult,
        skuids = [],
        buynum = [],
        totalnum = 0,
        totalmoney = 0,
        noneList = []
      shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      if (shopConfirmResult) shopConfirmResult.notbuygift_changebuy_money = 0
      for (let i = 0; i < list.length; i++) {
        let changebuylist = list[i].changebuylist
        for (let j = 0; j < changebuylist.length; j++) {
          if (changebuylist[j].ischoose) {
            currentList.push(changebuylist[j])
          }
        }
      }

      if (this.$route.query.type == 'orderInfo' && !currentList.length) {
        this.$toast('请选择要加购的商品')
        return
      }

      if (this.$route.query.type == 'orderInfo') {
        for (let i = 0; i < currentList.length; i++) {
          if (currentList[i].num == 0) {
            noneList.push(currentList[i].name)
          }
        }

        let tooltip = noneList.join()
        if (tooltip) {
          this.$toast(tooltip + '无加购资格')
          return
        }
      }

      currentList.forEach((item) => {
        skuids.push(item.skuid)
        buynum.push(item.num)
        totalnum += item.num
        totalmoney += item.num * item.changebuy_price
        if (item.isfullgift == 0 && shopConfirmResult) {
          shopConfirmResult.notbuygift_changebuy_money += item.num * item.changebuy_price
        }
      })

      if (this.$route.query.type != 'orderInfo' && !currentList.length) {
        shopConfirmResult.changebuy_list = JSON.stringify(currentList)
        shopConfirmResult.changebuyskuids = skuids
        shopConfirmResult.changebuynums = buynum
        localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
        if (this.$route.query.path) {
          this.$router.replace({
            path: unencryption(this.$route.query.path)
          })
        } else {
          let obj = {}
          if (this.$route.query.isexchange == 1) obj.isexchange = 1
          this.$router.replace({
            path: '/order',
            query: obj
          })
        }
        return
      }
      url = this.$ajax.checkOrder_URL + '?skuids=' + skuids.join() + '&buynum=' + buynum.join()
      url = this.$route.query.oid ? url + '&oid=' + this.$route.query.oid : url
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code == 200) {
          if (this.$route.query.type == 'orderInfo') {
            shopConfirmResult = {
              skuidArr: skuids,
              itemNum: buynum,
              skuidArrOversea: [],
              orderid: this.$route.query.oid,
              liveId: [],
              from: 2,
              orderfrom: 1,
              itemNumOversea: [],
              LiveIdArrOversea: [],
              totalmoney: totalmoney,
              totalnum: totalnum,
              orderHadOnShow: 0,
              isInitData: 1,
              changebuy_list: JSON.stringify([])
            }

            localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
          } else {
            shopConfirmResult.changebuy_list = JSON.stringify(currentList)
            shopConfirmResult.changebuyskuids = skuids
            shopConfirmResult.changebuynums = buynum
            localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
          }
          if (this.$route.query.path) {
            this.$router.push({
              path: unencryption(this.$route.query.path)
            })
          } else {
            let obj = {}
            if (this.$route.query.isexchange == 1) obj.isexchange = 1
            this.$router.push({
              path: '/order',
              query: obj
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/common/css/productList.scss';
.btnBox {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 0.5rem;
  line-height: 0.5rem;
  background: #fff;
  .submitBtn {
    position: absolute;
    right: 0.1rem;
    top: 0.06rem;
    width: 1.1rem;
    height: 0.38rem;
    line-height: 0.38rem;
    background: linear-gradient(to right, #fc0324, #ff144f);
    border-radius: 0.2rem;
    font-size: 0.16rem;
    color: #fff;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/productList/productList.vue